<template>
  <div>
    <!-- snackbar -->
    <SnackbarNew
      :snackbar.sync="snackbar"
      :snackbarError="snackbarError"
      :snackbarMessage="snackbarMessage"
    />
    <!-- For Extension -->
    <div v-if="extension" class="d-flex flex-column justify-center mt-8 w-100">
      <!-- Comment Dialog Box -->
      <template v-if="isExtension" v-show="openCommentDialog">
        <CommentsDialogBox
          :openCommentDialog.sync="openCommentDialog"
          :taskDetails="details"
          :getTaskComments="getTaskComments"
        />
      </template>
      <!-- Timer modes -->
      <div class="mt-2 ml-3 mb-2 d-flex align-center">
        <!-- Timer -->
        <v-btn
          height="35"
          width="182"
          @click="manualTaskFlag = false"
          outlined
          class="d-flex align-center theme-border rounded theme-light-bg py-3"
        >
          <v-icon size="20" class="mr-2">mdi-clock-outline</v-icon>
          <span class="body-2 text-capitalize">Timer mode</span>
        </v-btn>
        <!-- Manual -->
        <span :class="getActiveTask ? 'disable-cursor' : 'pointer'">
          <v-btn
            :disabled="getActiveTask ? true : false"
            @click="manualTaskFlag = true"
            height="35"
            width="182"
            outlined
            class="d-flex align-center theme-border rounded theme-light-bg ml-2 py-3"
          >
            <v-icon size="20" class="mr-2">mdi-calendar-edit</v-icon>
            <span class="body-2 text-capitalize">Manual mode</span>
          </v-btn>
        </span>
      </div>
      <!-- Timer Card -->
      <v-card
        width="374px"
        height="55px"
        class="d-flex ml-3 mb-2 align-center justify-center theme-border"
        outlined
      >
        <Timer class="py-1" v-if="!manualTaskFlag" :extension="true" />
        <div v-else>
          <!-- start/end time input -->
          <div class="d-flex w-100 align-center justify-start">
            <!-- Start Time -->
            <v-menu
              ref="startTimePicker"
              v-model="startTimePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <input
                  v-on="on"
                  type="time"
                  ref="startTime"
                  v-model="startTime"
                />
              </template>
              <v-time-picker
                class="timePicker"
                v-if="startTimePicker"
                v-model="startTime"
                type="month"
                width="290"
              ></v-time-picker>
            </v-menu>
            <span class="mr-2">-</span>
            <!-- Stop Time -->
            <v-menu
              ref="endTimePicker"
              v-model="endTimePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <input v-on="on" type="time" ref="endTime" v-model="endTime" />
              </template>
              <v-time-picker
                class="timePicker"
                v-if="endTimePicker"
                v-model="endTime"
                type="month"
                width="290"
              ></v-time-picker>
            </v-menu>
            <!-- Dates -->
            <!-- manual time selection icon  -->
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              color="#302277"
              bottom
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-menu
                    v-on="on"
                    :close-on-content-click="false"
                    tile
                    bottom
                    offset-y
                    min-width="366px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-menu
                        v-on="on"
                        v-model="manualDatePicker"
                        :close-on-content-click="false"
                        :nudge-left="80"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            button
                            :color="manualTaskFlag ? '#2A206A' : '#DCD8F3'"
                            >mdi-calendar</v-icon
                          >
                        </template>
                        <!-- <v-date-picker
                            v-model="manualEntryDate"
                          ></v-date-picker> -->
                      </v-menu>
                    </template>
                  </v-menu>
                </div>
              </template>
              <span>{{
                today.slice(8) +
                  today.slice(4, 7) +
                  "  to  " +
                  today.slice(8) +
                  today.slice(4, 7)
              }}</span>
            </v-tooltip>
            <v-divider class="mx-3" vertical></v-divider>
            <h2 class="success-text ml-2">
              {{ manualDuration ? manualDuration : "00:00:00" }}
            </h2>
          </div>
        </div>
      </v-card>
      <!-- Ranges -->
      <v-card
        v-if="manualTaskFlag"
        width="374px"
        class="ml-3 px-2 align-center theme-border"
        outlined
        ><v-range-slider
          hide-details
          v-model="timeEntryRange"
          @end="updateInterval"
          :max="1440"
          :step="1"
          :min="0"
          color="#1CC283"
          track-color="#E6E6E6"
          track-fill-color="#9185E0"
        >
        </v-range-slider>
        <RangeSliderLabels
      /></v-card>
      <!-- Task Title -->
      <div>
        <v-textarea
          class="my-2 ml-3 mr-10 theme-border body-1"
          hide-details
          solo
          height="130"
          v-model="taskTitle"
          flat
          autofocus
          color="#757096"
          placeholder="Add task title"
          @keydown.enter="
            !manualTaskFlag;
            getActiveTask
              ? changeTitle(getActiveTask)
              : getOnlineStatus
              ? (openMemberList = true)
              : () => {};
          "
          @keydown.tab="
            getSelectedCompany.role != 'employee'
              ? (openMemberList = true)
              : (openProjectList = true)
          "
          :disabled="
            getActiveTask
              ? getActiveTask.assigned_by.id != getLoggedInUser.id &&
                getSelectedCompany.role == 'employee'
                ? true
                : false
              : false
          "
        ></v-textarea>
      </div>
      <!-- Members list -->
      <MembersList
        :extension="true"
        :open="openMemberList"
        :clearMembers="!taskMembers.length"
        @assignedMembers="assignMembers"
        @dropdownClosed="openMemberList = false"
        @membersDone="openProjectList = true"
      />
      <!-- Project Name -->
      <ProjectList
        :extension="true"
        :open="openProjectList"
        @assignProject="assignProject"
        @dropdownClosed="openProjectList = false"
        @projectDone="
          taskMembers.length >= 0 &&
          !taskMembers.find((item) => {
            return item.id == getLoggedInUser.id;
          })
            ? focusStartAssign()
            : focusStart()
        "
      />

      <!-- Start/Stop/Assign Button -->
      <div v-if="!manualTaskFlag">
        <div
          v-if="
            getSelectedCompany.role == 'employee' &&
              !taskMembers.find((item) => {
                return item.id == getLoggedInUser.id;
              })
          "
        >
          <!-- Start/Stop Button -->
          <v-btn
            :x-small="$mq == 'extraSmallPhones' || $mq == 'miniMobilePhones'"
            :small="$mq == 'phone' || $vuetify.breakpoint.xs"
            :disabled="
              getQueue.length || (getActiveTask && !getOnlineStatus)
                ? true
                : false || !getOnlineStatus
            "
            width="374px"
            height="40px"
            class="pointer ml-3 white--text"
            id="start-stop-assign"
            @click="
              getActiveTask
                ? getOnlineStatus
                  ? stopTask()
                  : () => {}
                : taskMembers.length > 0 &&
                  !taskMembers.find((item) => {
                    return item.id == getLoggedInUser.id;
                  })
                ? assignTask()
                : startTask('start_task')
            "
            :class="[
              { 'mx-2': !$vuetify.breakpoint.xs },
              {
                'mt-1': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm,
              },
              getQueue.length || (getActiveTask && !getOnlineStatus)
                ? 'grey-btn'
                : getActiveTask
                ? 'stop-btn'
                : (getSelectedCompany.role == 'owner' ||
                    getSelectedCompany.role == 'admin' ||
                    getSelectedCompany.role == 'team-manager') &&
                  taskMembers.length == 0
                ? 'assign-btn'
                : taskMembers.length > 0 &&
                  !taskMembers.find((item_id) => {
                    return item_id == getLoggedInUser.id;
                  })
                ? 'assign-btn'
                : 'theme-filled-btn',
            ]"
            text
          >
            <label>
              {{
                getActiveTask
                  ? "Stop"
                  : (getSelectedCompany.role == "owner" ||
                      getSelectedCompany.role == "admin" ||
                      getSelectedCompany.role == "team-manager") &&
                    taskMembers.length == 0
                  ? "Assign"
                  : taskMembers.length > 0 &&
                    !taskMembers.find((item_id) => {
                      return item_id == getLoggedInUser.id;
                    })
                  ? "Assign"
                  : "Start"
              }}
            </label>
          </v-btn>
        </div>
        <!-- !Employee case -->
        <v-btn
          v-if="
            (getSelectedCompany.role != 'employee' &&
              !taskMembers.find((item) => {
                return item.id == getLoggedInUser.id;
              }) &&
              !getActiveTask) ||
              (getSelectedCompany.role != 'employee' &&
                getPendingTimer &&
                pending != 'start' &&
                !getActiveTask)
          "
          id="assign-task-check-ext"
          @click="
            getActiveTask
              ? getOnlineStatus
                ? stopTask()
                : () => {}
              : (taskMembers.length > 0 &&
                  !taskMembers.find((item_id) => {
                    return item_id == getLoggedInUser.id;
                  })) ||
                getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'owner' ||
                getSelectedCompany.role == 'team-manager'
              ? assignTask()
              : startTask('assign_start')
          "
          class="pointer body-2 white--text ml-3 assign-btn"
          :class="selectedItem == 2 ? 'bg-hover' : ''"
          text
          width="374px"
          height="40px"
        >
          Assign
        </v-btn>
        <v-btn
          v-else-if="getSelectedCompany.role != 'employee' && getActiveTask"
          class="stop-btn ml-3"
          depressed
          @click="
            getActiveTask ? (getOnlineStatus ? stopTask() : () => {}) : () => {}
          "
          width="374px"
        >
          Stop
        </v-btn>
        <!-- dropdown -->
        <div
          v-if="
            (taskMembers.find((item) => {
              return item.id == getLoggedInUser.id;
            }) &&
              !getPendingTimer) ||
              pending == 'start'
          "
        >
          <v-menu
            v-if="!getActiveTask"
            max-width="110px"
            content-class="dropdown-right"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @keydown.up="selectPrev"
                @keydown.down="selectNext"
                @click="
                  selectedItem == 1
                    ? startTask('start')
                    : selectedItem == 2
                    ? assignTask()
                    : () => {}
                "
                width="374px"
                id="start-stop-assign"
                :class="[
                  { 'mx-2': !$vuetify.breakpoint.xs },
                  {
                    'mt-1': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm,
                  },
                  getQueue.length || (getActiveTask && !getOnlineStatus)
                    ? 'grey-btn'
                    : (getSelectedCompany.role == 'owner' ||
                        getSelectedCompany.role == 'admin') &&
                      taskMembers.length == 0
                    ? 'assign-btn'
                    : taskMembers.length > 0 &&
                      !taskMembers.find((item) => {
                        return item.id == getLoggedInUser.id;
                      })
                    ? 'assign-btn'
                    : 'theme-filled-btn',
                ]"
                class="ml-3"
                text
                depressed
                v-bind="attrs"
                v-on="on"
              >
                {{
                  (getSelectedCompany.role == "owner" ||
                    getSelectedCompany.role == "admin") &&
                  taskMembers.length == 0
                    ? "Assign"
                    : taskMembers.length > 0 &&
                      !taskMembers.find((item) => {
                        return item.id == getLoggedInUser.id;
                      })
                    ? "Assign"
                    : "Start"
                }}
                <v-icon small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list class="pointer pa-0">
              <div class="pa-0 pt-1">
                <v-btn
                  :disabled="
                    taskMembers.length &&
                    !taskMembers.find((item) => {
                      return item.id == getLoggedInUser.id;
                    })
                      ? true
                      : false
                  "
                  @click="startTask('start')"
                  class="text-capitalize listing-hover subtitle-2"
                  :class="selectedItem == 1 ? 'bg-hover' : ''"
                  text
                  depressed
                  tile
                  id="s-task"
                  block
                  >Start Task</v-btn
                >
                <v-btn
                  :disabled="
                    getQueue.length ||
                    !taskMembers.length ||
                    (getActiveTask && !getOnlineStatus)
                      ? true
                      : false
                  "
                  @click="assignTask()"
                  class="text-capitalize listing-hover subtitle-2"
                  :class="selectedItem == 2 ? 'bg-hover' : ''"
                  text
                  depressed
                  tile
                  block
                  >Assign Task</v-btn
                >
              </div>
            </v-list>
          </v-menu>
        </div>
      </div>
      <!-- Add Manual Button -->
      <v-btn
        v-if="manualTaskFlag"
        @click="addTask()"
        depressed
        class="btn-success mx-3 white--text"
        width="374px"
        height="42px"
      >
        Add
      </v-btn>
      <!-- Discard button -->
      <v-btn
        v-if="getActiveTask"
        text
        elevation="0"
        class="ml-3 mt-2"
        solo
        width="374px"
        height="42px"
        @click="discard"
      >
        Discard
      </v-btn>
    </div>
    <!-- For Web -->
    <div v-else>
      <v-card
        class="d-flex align-center"
        elevation="0"
        :class="
          $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
            ? getActiveTask
              ? 'mx-3 mt-7 pt-0'
              : getQueue.length
              ? 'mx-3 mt-2 pt-0'
              : 'mx-3 mt-0 pt-0'
            : 'ml-6 d-flex'
        "
      >
        <!-- manual/auto timer buttons -->
        <div
          v-if="!$vuetify.breakpoint.xs"
          :class="[
            { 'flex-column': $mq == 'xs' || $vuetify.breakpoint.xs },

            $mq == 'miniMobilePhones'
              ? 'table-width-miniPhones'
              : $vuetify.breakpoint.md
              ? 'table-width-2'
              : $vuetify.breakpoint.sm
              ? 'table-width-3'
              : $vuetify.breakpoint.xs
              ? 'table-width-miniPhones'
              : getSidebarMini
              ? 'table-width-4'
              : 'table-width',
          ]"
          class="d-flex pa-1 theme-border-2 rounded"
        >
          <!-- Add Task Title Input Field  -->
          <v-text-field
            autocomplete="off"
            autofocus
            ref="newtask"
            id="task-title"
            hide-details
            dense
            color="#DCD8F3"
            v-model="taskTitle"
            placeholder="Add Task Title"
            solo
            flat
            class="pa-1 pt-1 custom-placeholer-color"
            @keydown.enter="
              getActiveTask
                ? changeTitle(getActiveTask)
                : getOnlineStatus
                ? (openMemberList = true)
                : () => {}
            "
            @keydown.tab="openMemberList = true"
            :disabled="
              getActiveTask
                ? getActiveTask.assigned_by.id != getLoggedInUser.id
                : false
            "
          >
            <template slot="append">
              <div
                v-if="$vuetify.breakpoint.xs && !isExtension"
                class="d-inline-block"
              >
                <Timer />
              </div>
            </template>
          </v-text-field>
          <v-divider v-if="$vuetify.breakpoint.xs || $mq == 'xs'"></v-divider>
          <div class="d-flex align-center justify-end">
            <!-- Member List component -->
            <div
              class=""
              :class="
                $vuetify.breakpoint.xs
                  ? ''
                  : getActiveTask
                  ? ''
                  : 'd-inline-flex'
              "
            >
              <MembersList
                :open="openMemberList"
                :clearMembers="!taskMembers.length"
                @assignedMembers="assignMembers"
                @dropdownClosed="openMemberList = false"
                @membersDone="openProjectList = true"
              />
            </div>
            <!-- ProjectList -->
            <div class="vertical-dotted-border"></div>
            <div
              class="mx-1"
              :class="
                $vuetify.breakpoint.xs
                  ? 'mr-1'
                  : getActiveTask
                  ? ''
                  : 'd-inline-flex'
              "
            >
              <ProjectList
                :open="openProjectList"
                @assignProject="assignProject"
                @dropdownClosed="openProjectList = false"
                @projectDone="
                  taskMembers.length >= 0 &&
                  !taskMembers.find((item) => {
                    return item.id == getLoggedInUser.id;
                  })
                    ? focusStartAssign()
                    : focusStart()
                "
              />
            </div>
            <!-- Timer -->
            <div
              v-if="!$vuetify.breakpoint.xs && getActiveTask"
              class="d-inline-flex vertical-dotted-border align-center px-4 pt-1"
            >
              <Timer />
            </div>
            <!-- Start/Stop/Assign Button -->
            <!-- Employee case -->
            <div
              v-if="
                getSelectedCompany.role == 'employee' &&
                  !taskMembers.find((item) => {
                    return item.id == getLoggedInUser.id;
                  })
              "
              class="vertical-dotted-border px-2 my-1"
            >
              <!-- Start/Stop Button -->
              <v-btn
                :x-small="
                  $mq == 'extraSmallPhones' || $mq == 'miniMobilePhones'
                "
                :small="$mq == 'phone' || $vuetify.breakpoint.xs"
                :disabled="
                  getQueue.length || (getActiveTask && !getOnlineStatus)
                    ? true
                    : false || !getOnlineStatus
                "
                class="pointer white--text"
                id="start-stop-assign"
                @click="
                  getActiveTask
                    ? getOnlineStatus
                      ? stopTask()
                      : () => {}
                    : taskMembers.length > 0 &&
                      !taskMembers.find((item) => {
                        return item.id == getLoggedInUser.id;
                      })
                    ? assignTask()
                    : startTask('start_task')
                "
                :class="[
                  { 'mx-2': !$vuetify.breakpoint.xs },
                  {
                    'mt-1': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm,
                  },
                  getQueue.length || (getActiveTask && !getOnlineStatus)
                    ? 'grey-btn'
                    : getActiveTask
                    ? 'stop-btn'
                    : (getSelectedCompany.role == 'owner' ||
                        getSelectedCompany.role == 'admin' ||
                        getSelectedCompany.role == 'team-manager') &&
                      taskMembers.length == 0
                    ? 'assign-btn'
                    : taskMembers.length > 0 &&
                      !taskMembers.find((item_id) => {
                        return item_id == getLoggedInUser.id;
                      })
                    ? 'assign-btn'
                    : 'theme-filled-btn',
                ]"
                text
              >
                <label>
                  {{
                    getActiveTask
                      ? "Stop"
                      : (getSelectedCompany.role == "owner" ||
                          getSelectedCompany.role == "admin" ||
                          getSelectedCompany.role == "team-manager") &&
                        taskMembers.length == 0
                      ? "Assign"
                      : taskMembers.length > 0 &&
                        !taskMembers.find((item_id) => {
                          return item_id == getLoggedInUser.id;
                        })
                      ? "Assign"
                      : "Start"
                  }}
                </label>
              </v-btn>
            </div>
            <!-- !Employee case -->
            <div
              v-if="getSelectedCompany.role != 'employee'"
              class="vertical-dotted-border mr-2"
            ></div>
            <div>
              <v-btn
                v-if="
                  (getSelectedCompany.role != 'employee' &&
                    !taskMembers.find((item) => {
                      return item.id == getLoggedInUser.id;
                    }) &&
                    !getActiveTask) ||
                    (getSelectedCompany.role != 'employee' &&
                      getPendingTimer &&
                      pending != 'start' &&
                      !getActiveTask)
                "
                id="assign-task-check"
                @click="
                  getActiveTask
                    ? getOnlineStatus
                      ? stopTask()
                      : () => {}
                    : (taskMembers.length > 0 &&
                        !taskMembers.find((item_id) => {
                          return item_id == getLoggedInUser.id;
                        })) ||
                      getSelectedCompany.role == 'admin' ||
                      getSelectedCompany.role == 'owner' ||
                      getSelectedCompany.role == 'team-manager'
                    ? assignTask()
                    : startTask('assign_start')
                "
                class="pointer body-2 white--text mx-1 mt-1 assign-btn"
                :class="selectedItem == 2 ? 'bg-hover' : ''"
                text
                width="105px"
                height="40px"
                :disabled="!getOnlineStatus"
              >
                Assign
              </v-btn>
              <v-btn
                v-else-if="
                  getActiveTask && getSelectedCompany.role != 'employee'
                "
                class="mx-1 mt-1 stop-btn"
                depressed
                @click="
                  getActiveTask
                    ? getOnlineStatus
                      ? stopTask()
                      : () => {}
                    : () => {}
                "
              >
                Stop
              </v-btn>
              <!-- <v-btn
                v-else-if="
                  getSelectedCompany.role == 'employee' &&
                  taskMembers.find((item_id) => {
                    return item_id == getLoggedInUser.id;
                  }) &&
                  getPendingTimer
                "
                class="pointer white--text theme-filled-btn"
                text
                >Start 2</v-btn
              > -->
            </div>
            <!-- dropdown -->
            <div
              v-if="
                (taskMembers.find((item) => {
                  return item.id == getLoggedInUser.id;
                }) &&
                  !getPendingTimer) ||
                  pending == 'start'
              "
            >
              <v-menu
                v-if="!getActiveTask"
                offset-y
                max-width="110px"
                content-class=" dropdown-right"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @keydown.up="selectPrev"
                    @keydown.down="selectNext"
                    @click="
                      selectedItem == 1
                        ? startTask('start')
                        : selectedItem == 2
                        ? assignTask()
                        : () => {}
                    "
                    id="start-stop-assign"
                    :class="[
                      { 'mx-2': !$vuetify.breakpoint.xs },
                      {
                        'mt-1':
                          $vuetify.breakpoint.xs || $vuetify.breakpoint.sm,
                      },
                      getQueue.length || (getActiveTask && !getOnlineStatus)
                        ? 'grey-btn'
                        : (getSelectedCompany.role == 'owner' ||
                            getSelectedCompany.role == 'admin') &&
                          taskMembers.length == 0
                        ? 'assign-btn'
                        : taskMembers.length > 0 &&
                          !taskMembers.find((item) => {
                            return item.id == getLoggedInUser.id;
                          })
                        ? 'assign-btn'
                        : 'theme-filled-btn',
                    ]"
                    text
                    depressed
                    v-bind="attrs"
                    v-on="on"
                    :disabled="!getOnlineStatus"
                  >
                    {{
                      (getSelectedCompany.role == "owner" ||
                        getSelectedCompany.role == "admin" ||
                        getSelectedCompany.role == "team-manager") &&
                      taskMembers.length == 0
                        ? "Assign"
                        : taskMembers.length > 0 &&
                          !taskMembers.find((item) => {
                            return item.id == getLoggedInUser.id;
                          })
                        ? "Assign"
                        : "Start"
                    }}
                    <v-icon small>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list class="pointer pa-0">
                  <div class="pa-0 pt-1">
                    <v-btn
                      :disabled="
                        taskMembers.length &&
                        !taskMembers.find((item) => {
                          return item.id == getLoggedInUser.id;
                        })
                          ? true
                          : false
                      "
                      @click="startTask('start')"
                      class="text-capitalize listing-hover subtitle-2"
                      :class="selectedItem == 1 ? 'bg-hover' : ''"
                      text
                      depressed
                      tile
                      id="s-task"
                      block
                      >Start Task</v-btn
                    >
                    <v-btn
                      :disabled="
                        getQueue.length ||
                        !taskMembers.length ||
                        (getActiveTask && !getOnlineStatus)
                          ? true
                          : false
                      "
                      @click="assignTask()"
                      class="text-capitalize listing-hover subtitle-2"
                      :class="selectedItem == 2 ? 'bg-hover' : ''"
                      text
                      depressed
                      tile
                      block
                      >Assign Task</v-btn
                    >
                  </div>
                </v-list>
              </v-menu>
            </div>
            <!-- Cancel Icon-->
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              v-if="getActiveTask"
              bottom
              color="#302277"
            >
              <!-- tooltip template -->
              <template v-slot:activator="{ on }">
                <v-menu
                  v-on="on"
                  v-model="discardTaskMenu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      :class="$vuetify.breakpoint.xs ? 'my-2' : 'my-1 mx-1'"
                      :disabled="!getOnlineStatus"
                      icon
                      x-small
                      grey
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <!-- discard task confirmation dialog -->
                  <v-card height="90" :class="isMac ? 'edited_scrollbar' : ''">
                    <v-card-text>
                      <span>Are you sure?</span>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="highlight"
                        outlined
                        tile
                        x-small
                        @click="discardTaskMenu = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        @click="discard"
                        x-small
                        class="btn-success darken-1 white--text"
                        tile
                      >
                        Discard
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </template>
              <span>Cancel</span>
            </v-tooltip>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
import requestQueue from "@/services/requestQueue";
import timer from "@/timer.js";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import { rangeSlider } from "@/mixins/rangeSlider";
import { momentHelper } from "@/mixins/momentHelper";
import { tasksMixin } from "@/mixins/tasksMixin";

export default {
  name: "StartTask",
  components: {
    ProjectList: () => import("../Projects/ProjectList"),
    Timer: () => import("@/components/Tasks/Timer"),
    MembersList: () => import("../TeamMembers/MembersList"),
    RangeSliderLabels: () => import("./RangeSliderLabels"),
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
    CommentsDialogBox: () => import("./Comments/CommentsDialogBox"),
  },
  mixins: [
    snackbarMixin,
    momentHelper,
    rangeSlider,
    window.innerHeight == "600" && window.innerWidth == "450" ? tasksMixin : "",
  ],
  props: ["stopped", "extension"],
  data() {
    return {
      dialogOpen:false,
      openCommentDialog: false,
      taskDetails: null,
      getTaskComments: "",
      selectedItem: null,
      manualDatePicker: false,
      timeEntryRange: [
        moment
          .duration(
            moment()
              .subtract(1, "hour")
              .diff(moment("00:00:00", "HH:mm:ss"))
          )
          .asMinutes(),
        moment
          .duration(moment().diff(moment("00:00:00", "HH:mm:ss")))
          .asMinutes(),
      ],
      manualTaskFlag: false,
      openMemberList: false,
      openProjectList: false,
      discardTaskMenu: false,
      taskMembers: [],
      taskTitle: "",
      manualEntryDate: moment().format("YYYY-MM-DD"),
      today: moment().format("YYYY-MM-DD"),
      startTime: moment()
        .subtract(1, "hour")
        .format("HH:mm"),
      endTime: moment().format("HH:mm"),
      pending: false, // pending API request
      startTimePicker: false,
      endTimePicker: false,
      manualDuration: null,
    };
  },
  computed: {
    ...mapGetters([
      "getActiveTask",
      "getSelectedCompany",
      "getSelectedProject",
      "getLoggedInUser",
      "getActiveTimeEntry",
      "getQueue",
      "getOnlineStatus",
      "getSidebarMini",
      "getView",
      "getPendingTimer",
    ]),
  },

  methods: {
    focusStartAssign() {
      if (this.isExtension) {
        //document.getElementById("assign-task-check-ext").click();
        this.getActiveTask
          ? this.getOnlineStatus
            ? this.stopTask()
            : () => {}
          : this.taskMembers.length >= 0 &&
            !this.taskMembers.find((item) => {
              //this.assignTask()
              return item.id == this.getLoggedInUser.id;
            })
          ? this.assignTask()
          : this.startTask("assign_start");
      } else {
        this.getActiveTask
          ? this.getOnlineStatus
            ? this.stopTask()
            : () => {}
          : this.taskMembers.length >= 0 &&
            !this.taskMembers.find((item) => {
              //this.assignTask()
              return item.id == this.getLoggedInUser.id;
            })
          ? this.assignTask()
          : this.startTask("assign_start");
      }
    },
    // Calculates manual duration when start/stop time/date is changed
    calculateManualDuration() {
      let startMoment = this.getMomentHM(this.manualEntryDate, this.startTime);
      let stopMoment = this.getMomentHM(this.manualEntryDate, this.endTime);
      return timer.format(
        moment.duration(stopMoment.diff(startMoment)).asSeconds()
      );
    },
    updateInterval(range) {
      let { endHours, endMinutes } = this.calculateInterval(range);
      this.endTime = `${endHours}:${endMinutes}`;
      this.manualDuration = this.calculateManualDuration();
    },
    // Updates title if title is changed from list
    updateTitle(title) {
      this.taskTitle = title;
    },
    // focuses start button
    focusStart() {
      if (document.getElementById("start-stop-assign")) {
        document.getElementById("start-stop-assign").focus();
      } else if (document.getElementById("add-manual")) return this.addTask();
      // if (!this.manualTaskFlag) this.startTask();
      // else this.addTask();
    },
    selectPrev() {
      if (
        this.taskMembers.length &&
        !this.taskMembers.find((item) => {
          return item.id == this.getLoggedInUser.id;
        })
      ) {
        this.selectedItem = 2;
      } else if (
        this.getQueue.length ||
        !this.taskMembers.length ||
        (this.getActiveTask && !this.getOnlineStatus)
      ) {
        this.selectedItem = 1;
      } else {
        if (this.selectedItem != null) {
          if (this.selectedItem <= 0) {
            this.selectedItem = 2;
          } else {
            this.selectedItem -= 1;
          }
        } else {
          this.selectedItem = 1;
        }
      }
    },
    selectNext() {
      if (
        this.taskMembers.length &&
        !this.taskMembers.find((item) => {
          return item.id == this.getLoggedInUser.id;
        })
      ) {
        this.selectedItem = 2;
      } else if (
        this.getQueue.length ||
        !this.taskMembers.length ||
        (this.getActiveTask && !this.getOnlineStatus)
      ) {
        this.selectedItem = 1;
      } else {
        if (this.selectedItem != null) {
          if (this.selectedItem >= 2) {
            this.selectedItem = 1;
          } else {
            this.selectedItem += 1;
          }
        } else {
          this.selectedItem = 1;
        }
      }
    },
    assignMembers(members) {
      this.taskMembers = members;
    },

    validateTitle() {
      let title = this.taskTitle.trim();
      if (!title) {
        this.openSnackbar(true, "Title is Required");
        return false;
      } else if (title.length < 2) {
        this.openSnackbar(true, "Title must be at least two characters long");
        return false;
      } else if (title.length > 255) {
        this.openSnackbar(true, "Title must not exceed 50 characters");
        return false;
      }
      return true;
    },
    // Validate start and end times for manual entry
    validateTimeEntries() {
      var start = this.getMomentHMS(
        this.manualEntryDate,
        `${this.startTime}:00`
      );
      var stop = this.getMomentHMS(this.manualEntryDate, `${this.endTime}:00`);
      return {
        start,
        stop,
        duration: moment.duration(stop.diff(start)).asSeconds(),
      };
    },

    // Creates task request payload
    createTask() {
      let members;
      // for employee
      if (this.getSelectedCompany.role == "employee") {
        !this.taskMembers.length
          ? this.taskMembers.push(this.getLoggedInUser.id)
          : (this.taskMembers = this.taskMembers.map((item) => {
              return item.id;
            }));
      }
      // for admin, owner & team lead
      else if (this.getSelectedCompany.role != "employee") {
        if (
          this.taskMembers.length ||
          (this.taskMembers.length && this.getSelectedProject)
        ) {
          this.taskMembers = this.taskMembers.map((item) => {
            return item.id;
          });
        }
        if (this.getSelectedProject && !this.taskMembers.length) {
          if (!this.taskMembers.length) {
            if (
              this.getSelectedProject.project_leads
                ? !this.getSelectedProject.project_leads.length
                : true
            ) {
              this.taskMembers = [];
            } else {
              this.taskMembers = [];
              this.taskMembers = this.getSelectedProject.project_leads;
            }
          } else {
            this.taskMembers = this.taskMembers.map((item) => {
              return item.id;
            });
          }
        }
      }
      let title = this.taskTitle;
      return {
        company_id: this.getSelectedCompany.id,
        project_id: this.getSelectedProject ? this.getSelectedProject.id : null,
        title,
        due_date: "",
        members: this.taskMembers,
        end_time: "",
        duration: "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        self_assigned: this.taskMembers.find((item_id) => {
          return item_id == this.getLoggedInUser.id;
        })
          ? true
          : false,
      };
    },

    // Add manual time
    addTask() {
      if (this.pending) return;
      this.pending = "manual";
      let times = this.validateTimeEntries(); // get time entry
      let body = this.createTask(); // get request payload
      body.start_time = times.start.format("YYYY-MM-DD HH:mm:ss");
      body.end_time = times.stop.format("YYYY-MM-DD HH:mm:ss");
      body.duration = times.duration;
      body.status = "pending";
      if (this.validateTitle()) {
        this.$store
          .dispatch("createTask", body)
          .then(() => {
            this.pending = false;
            this.taskTitle = "";
            // when no error messages
            this.openSnackbar(false, "Task Added successfully");
          })
          .catch(() => {
            this.pending = false;
          });
        this.manualTaskFlag = false;
        this.manualDuration = null;
      }
    },

    // Create and play task
    startTask(reqType) {
      this.taskTitle = this.taskTitle.trim();
      if (this.pending) return;
      if (this.taskMembers.length > 1 && !this.taskTitle) {
        return this.openSnackbar(true, "Cannot assign task without title");
      }
      if (this.taskTitle.length == 0)
        return this.openSnackbar(true, "Please enter title to start the task");
      else if (this.taskTitle.length == 1) {
        return this.openSnackbar(
          true,
          "Title must be at least two characters long"
        );
      }

      let newTask = this.createTask();
      if (
        this.getSelectedCompany.role == "owner" ||
        this.getSelectedCompany.role == "admin"
      ) {
        if (!this.getSelectedProject && !this.taskMembers.length) {
          return this.openSnackbar(true, "Please select a project or member");
        }
        // if (this.getSelectedProject && !this.taskMembers.length) {
        //   return;
        // }
      }
      newTask.status = "active";
      newTask.future_task = false;
      newTask.start_time = moment().format("YYYY-MM-DD HH:mm:ss");
      this.$store
        .dispatch("createTask", newTask)
        .then((res) => {
          this.selectedItem = null;
          this.$store.commit("setActiveTask", res.data);
          this.taskMembers = [];
          this.pending = false;
          this.openSnackbar(false, res.error_msg);
        })
        .catch(() => {
          this.taskTitle = "";
          this.pending = false;
        });
      newTask.members.length > 1 ? eventBus.$emit("newTaskAssigned") : () => {};
    },

    // Create and assign task
    assignTask() {
      if (this.pending) return;
      if (this.validateTitle()) {
        this.pending = "assign";
        let newTask = this.createTask();
        if (!this.getSelectedProject && !this.taskMembers.length) {
          this.pending = null;
          return this.openSnackbar(true, "Please select a project or member");
        }
        let futureTask = this.taskMembers.find((item_id) => {
          return item_id == this.getLoggedInUser.id;
        })
          ? true
          : false;
        if (futureTask) {
          newTask.future_task = true;
        }
        newTask.start_time = "";
        newTask.status = "pending";
        this.$store
          .dispatch("createTask", newTask)
          .then((response) => {
            this.dialogOpen = true
            this.openSnackbar(false,response.error_msg)
            // for dialog open
             !futureTask || (futureTask && this.taskMembers.length > 1)
          ? eventBus.$emit("newTaskAssigned")
          : () => {};
          // end of dialog
            this.taskMembers = [];
            this.$store.commit("setSelectedProject", null);
            this.taskTitle = "";
            this.selectedItem = null;
            this.pending = false;
            this.dialogOpen = true;
            document.getElementById("start-stop-assign").focusout();
          })
          .catch((error) => {
            this.dialogOpen = false; 
           this.openSnackbar(true,error.response.data.error_msg)
            setTimeout(() => {
               window.location.reload();
             }, 2000);
          });
      }
    },
    //Stop the running task
    stopTask() {
      if (this.pending) return;
      this.pending = "stop";
      this.$emit("stopAttempt");
      if (this.validateTitle()) {
        this.changeTitle(this.getActiveTask).then(() => {
          this.$store
            .dispatch("stopTask")
            .then(() => {
              this.pending = false;
              this.taskMembers = [];
              this.taskTitle = "";
            })
            .catch((error) => {
              this.taskTitle = "";
              this.pending = false;
              if (error) {
                if (
                  error.response &&
                  error.response.data &&
                  error.response.data.message ==
                    "Trying to access array offset on value of type null"
                ) {
                  this.$store.commit("setActiveTask", null);
                  this.$store.commit("resetTimer");
                  this.$store.dispatch("fetchTasks");
                }
              }
            });
        });
      } else this.pending = false;
    },

    // Assign project to running task
    assignProject(project) {
      let body = {
        project_id: project ? project.id : null,
        company_id: this.getSelectedCompany.id,
        task_id: this.getActiveTask.task_id,
      };
      this.$store.dispatch("updateTask", body);
    },

    // Change title of running task
    changeTitle(task) {
      let title = this.taskTitle;
      if (title != "" && title != task.title) {
        return new Promise((resolve) => {
          this.$store
            .dispatch("updateTask", {
              company_id: this.getSelectedCompany.id,
              task_id: task.task_id,
              title,
            })
            .then(() => {
              resolve(true);
            })
            .catch((error) => {
              this.openSnackbar(true, error.response.data.errors.title[0]);
            });
        });
      } else
        return new Promise((resolve) => {
          resolve();
        });
    },

    // discard time for running task
    discard() {
      // to close the dropdown menu until 'x' icon is clicked again
      this.discardTaskMenu = false;
      if (this.pending) return;
      this.pending = "discard";
      this.$store
        .dispatch("discardTask", {
          company_id: this.getSelectedCompany.id,
          time_entries: [this.getActiveTimeEntry.entry_id],
        })
        .then(() => {
          this.pending = false;
          this.taskTitle = "";
          this.$store.commit("setActiveTask", null);
        })
        .catch(() => {
          this.$store.commit("setActiveTask", null);
          this.$store.commit("resetTimer");
          this.pending = false;
        });
    },
  },

  mounted() {
    // listen for online
    window.ononline = () => {
      //start queue
      if (
        (localStorage.getItem("token") || localStorage.getItem("user")) &&
        this.getQueue.length
      ) {
        requestQueue.startQueue();
      }
    };

    if (this.getActiveTask) {
      this.taskTitle = this.getActiveTask.title;
    }
    eventBus.$on("titleUpdated", this.updateTitle);
  },

  beforeDestroy() {
    eventBus.$off("newTaskAssigned");
  },

  watch: {
    // Update range slider when start time of entry is updated by keyboard
    startTime(value) {
      if (value) {
        this.timeEntryRange = [
          moment
            .duration(
              moment(value, "HH:mm:ss").diff(moment("00:00:00", "HH:mm:ss"))
            )
            .asMinutes(),
          this.timeEntryRange[1],
        ];
      }
    },
    // Update range slider when end time of entry is updated by keyboard
    endTime(value) {
      if (value) {
        this.timeEntryRange = [
          this.timeEntryRange[0],
          moment
            .duration(
              moment(value, "HH:mm:ss").diff(moment("00:00:00", "HH:mm:ss"))
            )
            .asMinutes(),
        ];
      }
    },
    // Signal from list to stop task
    stopped(value) {
      value ? this.stopTask() : () => {};
    },

    getActiveTask(value) {
      if (value) {
        this.manualTaskFlag = false;
        this.taskTitle = value.title;
      }
      if (!value) this.taskTitle = "";
    },

    openProjectList(value) {
      if (value) this.openMemberList = false;
    },

    manualTaskFlag() {
      this.manualDuration = this.calculateManualDuration();
    },
  },
};
</script>
<style scoped>
.bg-hover {
  background-color: #e5efff !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: #dcd8f3;
}
/* light purple background color */
.theme-light-bg {
  background-color: rgba(237, 235, 249, 0.4);
}
.custom-placeholer-color input::placeholder {
  color: red !important;
  opacity: 1;
}
.border {
  border: 1px solid rgb(201, 196, 196);
  border-radius: 5;
}
.xs-font {
  padding-top: 3px;
  font-size: 0.66rem;
}
.stop-btn {
  color: white;
  background-color: #d52a5d !important;
}
.grey-btn {
  color: white;
  background-color: #e6adbe;
}
.assign-btn {
  color: #ffffff;
  background-color: #6c5cd6;
}
.xs-label {
  font-size: 10px;
  width: 60px;
}
.default-label {
  font-size: 16px;
  width: 124px;
}
.xs-date-css {
  font-size: 10px;
  width: 80px;
}
.default-date-css {
  width: 108px;
}
</style>
<style>
.v-application .primary {
  background-color: #2a206a !important;
  border-color: #2a206a !important;
}
.v-application .accent {
  background-color: #2a206a !important;
  border-color: #2a206a !important;
}
.time-style {
  height: 28px !important;
  width: 88px;
  text-align: center;
}
.time-style-sm {
  height: 24px !important;
  width: 48px;
  font-size: 10px;
  text-align: center;
}
.timePicker .v-picker__title {
  height: 50px !important;
  font-size: smaller !important;
}
.timePicker .v-time-picker-title__time .v-picker__title__btn,
.v-time-picker-title__time span {
  height: 25px;
  font-size: 40px;
}
input[type="time"]::-webkit-calendar-picker-indicator {
  display: none;
}
.timer-font {
  font-size: 16px;
  color: #2a206a;
}
.smallScreen-timer-font {
  font-size: 10px !important;
  color: #2a206a;
}
</style>
